var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666674 16.0001C1.03487 16.0001 1.33335 15.7016 1.33335 15.3334C1.33335 14.9652 1.03487 14.6667 0.666674 14.6667C0.29848 14.6667 0 14.9652 0 15.3334C0 15.7016 0.29848 16.0001 0.666674 16.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 5.33322L15.6097 3.72387C16.1304 3.2032 16.1304 2.35919 15.6097 1.83852L14.1617 0.390504C13.641 -0.130168 12.797 -0.130168 12.2763 0.390504L10.667 1.99985L14.0004 5.33322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3331 3.33325L1.50635 11.16C1.50635 11.16 2.11835 11.1053 2.34636 11.3333C2.57436 11.5613 2.38636 13.0534 2.66636 13.3334C2.94636 13.6134 4.42904 13.416 4.64171 13.6287C4.85438 13.8414 4.83972 14.4934 4.83972 14.4934L12.6665 6.66662L9.3331 3.33325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66646 14.3333L0.666449 13.3333L0.0371094 15.1146L0.309779 15.6899L1.66646 14.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66674 14.3333L2.66675 15.3333L0.885398 15.9626L0.310059 15.6899L1.66674 14.3333Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.4bacafa07afdfcf9f1653640f432518e.svg";
export { ForwardRef as ReactComponent };